import React from 'react';
import Clipboard from 'clipboard';
import Url from 'c-url';
import { config, giftService } from '../../config';
import ProjectDetailPb from '../../pb/giftitemdetail.pb';
import './step2.less';
import {createStepTwoCopy, createStepTwoSeeAll, enterCreateStepTwo} from '../../ga-config';

const getProjectById = giftService('/gift/item/detail', ProjectDetailPb.Gift.ItemDetail);

export default class Step2 extends React.Component {
    static defaultProps = {
        id: null, //  如果有id，就需要显示当前id的项目名称
        image: require('../../../images/land1.png'),
        onSeeAll() {
            //  查看所有
        },
        onNext() {
            // 会跳转到下一步的
        },
        onEdit() {
            // 点击了图像上的修改按钮
        }
    };

    constructor(props) {
        super(props);
        let queryObj = Url.parseQuery(Url.parse(location.href).query),
            queryResult = {};

        //  只获取路径上传递的语言和env参数，其他参数直接忽略
        Object.keys(queryObj).forEach(item => {
            if (['lang', 'env'].indexOf(item) !== -1) {
                queryResult[item] = queryObj[item];
            }
        });

        queryResult.hostid = UG.getUser().uid;
        queryResult.itemid = props.id;
        let url = config.publishUrl + '?' + $.param(queryResult) + '#/gift';

        this.state = {
            itemId: props.id,
            itemName: '',
            showNext: false,
            shareUrl: url
        };
    }

    componentDidMount() {
        this.initClipboard();
        this.fetchProjectInfo();
        GA.add(enterCreateStepTwo);
    }

    componentWillUnmount() {
        //  防止多次初始化
        this.clip && this.clip.destroy();
    }

    initClipboard() {
        const { onNext } = this.props;
        const { shareUrl } = this.state;
        // 初始化剪切板插件
        const clip = this.clip = new Clipboard('#ci-copy-link', {
            text() {
                return shareUrl;
            }
        });

        clip.on('success', () => {
            UG.simple(UG.lang.template('Copied Successfully!'));
            //  延迟跳转
            GA.add(createStepTwoCopy);
            setTimeout(onNext, 1000);
        });
        clip.on('error', () => {
            UG.simple(UG.lang.template('Copied failed. Please select the link and copy.'));
            //  延迟，防止直接就跳转到下一步了
            setTimeout(() => {
                this.setState({ showNext: true });
            }, 300);
        });
    }

    fetchProjectInfo() {
        getProjectById({ itemId: this.props.id, uid: UG.getUser().uid })
            .then(({ itemInfos }) => {
                const { itemName } = itemInfos;
                this.setState({ itemName });
            })
            .catch(err => {
                console.log('出现了错误了');
            });
    }

    render() {
        const { image, onSeeAll, onEdit, onNext } = this.props;
        const { showNext, itemName, shareUrl } = this.state;
        const editClick = () => {
            onEdit();
        };
        const seeAll = () => {
            GA.add(createStepTwoSeeAll);
            onSeeAll();
        };
        return (
            <div className="ci-step2">
                <div className="ci-step2-info text-center">
                    <img src={image}/>
                    <p className="ci-step2-uname ellipsis">{itemName}</p>
                    <i className="ci-step2-edit" onClick={editClick}/>
                </div>
                <div className="ci-step2-share text-center">
                    <input type="text" defaultValue={shareUrl}/>
                </div>
                <div className="text-center">
                    {
                        showNext
                            ? (
                                <button type="button" className="btn-cus btn-lg" onClick={onNext}>
                                    {UG.lang.template('Next Step')}
                                </button>
                            )
                            : (
                                <button type="button" className="btn-cus btn-lg" id="ci-copy-link">
                                    {UG.lang.template('Copy link')}
                                </button>
                            )
                    }
                    <div className="ci-step2-link-all" onClick={seeAll}>
                        {UG.lang.template('See all >')}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/host/gift/step2.js